// removed by extract-text-webpack-plugin
module.exports = {"page":"_2tKVHtS_H _30W7J4cYZ gkmejKHip NYy_UUBwl FoW7vlZMf _1HeoWRlgs","centered":"OD8PvmJXf _3EiT4eWlg _2Kz2o9zH0 _1FoUCLbbD _2l0xl0HVf _2nov6tC6P"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/drafts-page/drafts-page.css
 ** module id = 2185
 ** module chunks = 0
 **/